import { oauthSetupSteps } from "../oauthSetupSteps";
import { bearerAuth, oauthAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

export const faceit = defineProduct({
  name: "FACEIT",
  tagLine: "Competitive gaming, players, matches, and tournaments",
  logo,
  tags: ["data"],
  variants: [
    productVariant({
      identifier: "faceit",
      authLabel: "Data API key",
      protocol: "http",
      defaultUrlPattern: () => "https://open\\.faceit\\.com/data/v4/.*",
      auth: (app) => bearerAuth(app.secret.apiKey),
      steps: [
        {
          title: "Create a server-side API key",
          items: [
            {
              kind: "markdown",
              content:
                "Open your application in the [FACEIT Developer Portal](https://developers.faceit.com/), then create a server-side key in **API Keys**. This connector accesses public gaming data through the Data API; FACEIT Connect authorizes user identity separately.",
            },
            {
              kind: "input",
              label: "API key",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://open.faceit.com/data/v4/games?limit=1",
      },
    }),
    productVariant({
      identifier: "faceitOAuth",
      authLabel: "FACEIT Connect OAuth",
      protocol: "http",
      defaultUrlPattern: () =>
        "https://api\\.faceit\\.com/auth/v1/resources/.*",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "faceitOAuth",
        registrationUrl: "https://developers.faceit.com/",
        scopes: ["openid", "profile"],
        instructions:
          "Configure an OAuth2 consent screen and client in App Studio. This authorization accesses user identity; use the Data API key option for matches, players, and tournaments.",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () => "https://accounts.faceit.com",
        tokenEndpoint: () => "https://api.faceit.com/auth/v1/oauth/token",
        tokenEndpointAuthMethod: () => "client_secret_basic",
        clientCredentialsFrom: "db",
        scopes: () => ["openid", "profile"],
        pkce: () => true,
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://api.faceit.com/auth/v1/resources/userinfo",
      },
    }),
  ],
});
